import {EAlgoliaManagerEventType} from './IAlgoliaManager';
import {IEventData} from 'coreClasses/events/IEvents';

import EventModel from './eventModels/EventModel';

import GeneralFactory from 'coreClasses/GeneralFactory';
import AlgoliaProductSuggestionClickEventModel from './eventModels/algolia/AlgoliaProductSuggestionClickEventModel';
import AlgoliaProductAddToCartEventModel from './eventModels/algolia/AlgoliaProductAddToCartEventModel';

/**
 * Represents EventModelFactory
 */
class EventModelFactory extends GeneralFactory {
	/**
	 * Creates event model
	 * @param {EAlgoliaManagerEventType} eventType - event type
	 * @param {IEventData} eventData - event data
	 * @returns {EventModel} - event model
	 */
	create(eventType: EAlgoliaManagerEventType, eventData: IEventData): EventModel {
		let eventModel: EventModel = null;

		switch (eventType) {
			case EAlgoliaManagerEventType.PRODUCT_SUGGESTION_CLICK:
				eventModel = new AlgoliaProductSuggestionClickEventModel(eventData);

				break;
			case EAlgoliaManagerEventType.PRODUCT_ADD_TO_CART:
				eventModel = new AlgoliaProductAddToCartEventModel(eventData);

				break;
			default:
				break;
		}

		return eventModel;
	}
}

export default EventModelFactory;
